import { Helmet } from "react-helmet-async";
import PageHeader from "../../components/PageHeader";
import { filter } from "lodash";
import { sentenceCase } from "change-case";
import Papa from "papaparse";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CModel from "../../components/CModel/CModel";
// @mui
import {
  Card,
  Stack,
  Paper,
  Button,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Breadcrumbs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  Box,
  Snackbar,
} from "@mui/material";
import { WarningAmberRounded, Inventory2Outlined } from "@mui/icons-material";

import { HomeRounded } from "@mui/icons-material";

// components
import Label from "../../components/label";
import Iconify from "../../components/iconify";
import Scrollbar from "../../components/scrollbar";
// sections
import { UserListHead, UserListToolbar } from "../../sections/@dashboard/user";
// mock
import { useSelector } from "react-redux";
import { deleteJob, getJobs } from "../../feature/jobSlice";
import { fDate } from "../../utils/formatTime";
import ApiCall from "../../utils/apicall";
// import { readCSVFile } from '../../utils/readCSVFile';
// import { validateJobData } from '../../utils/validateJobData';
// import { jobCSVTamplate } from '../../utils/jobCSVTemplate';
import { hasPermission, PERMISSIONS } from "../../utils/hasPermission";

import SmartTable from "../../components/SmartTable/SmartTable";
const TABLE_HEAD = [
  { id: "name", label: "Project Name", alignRight: false },
  { id: "status", label: "status", alignRight: false },
  { id: "totalTasks", label: "Total Tasks", alignRight: false },
  { id: "completedTasks", label: "Completed Tasks", alignRight: false },
  { id: "startDate", label: "Start Date", alignRight: false },
  { id: "endDate", label: "End Date", alignRight: false },
  { id: "", label: "" },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Route merge 2026-05-05: default detail path now points at canonical
// /jobs/:id/detailing route. Pass detailBasePath="/detail-Job" if you need
// the legacy URL for back-compat (it auto-redirects to the canonical anyway).
export default function Jobs({ detailBasePath = "/jobs", moduleTitle = "Jobs", showJobActions = true } = {}) {
  const dispatch = useDispatch();
  let open = false;

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState("asc");

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState("name");

  const [filterName, setFilterName] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [selectedRow, setSelectedRow] = useState("");

  const [openModel, setOpenModel] = useState(false);

  const [openUpdateModel, setOpenUpdateModel] = useState(false);

  const { jobs, isJobLoading } = useSelector((state) => state.jobSlice);
  const [allJobs, setAllJobs] = useState([]);

  const { loginUser } = useSelector((state) => state.userSlice);
  const { permissions: userPermissions } = loginUser.decodedToken;
  const canAddJob = hasPermission(userPermissions, PERMISSIONS.ADD_JOB);
  const canEditJob = hasPermission(userPermissions, PERMISSIONS.EDIT_JOB);
  const canDeleteJob = hasPermission(userPermissions, PERMISSIONS.DELETE_JOB);
  const canExportJob = hasPermission(userPermissions, PERMISSIONS.EXPORT_JOB);
  const canViewJobList = hasPermission(userPermissions, PERMISSIONS.VIEW_JOB);
  const canDeatilJobList = hasPermission(
    userPermissions,
    PERMISSIONS.Detail_Job
  );

  // Note: previously fetched /job/export on mount (Codex CRITICAL — pulled
  // export-grade dataset for non-export users). Fix: defer until the user
  // clicks Export AND has EXPORT_JOB permission. Backend must enforce too.
  const fetchJobsForExport = async () => {
    if (!canExportJob) return null;
    try {
      const response = await ApiCall.get("/job/export");
      setAllJobs(response.data.data);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching jobs for export:", error);
      return null;
    }
  };

  const handleExport = async () => {
    if (!canExportJob) {
      console.warn("Export blocked: missing EXPORT_JOB permission");
      return;
    }
    let data = allJobs;
    if (!data || data.length === 0) {
      data = await fetchJobsForExport();
      if (!data) return;
    }
    const csvData = Papa.unparse(data, { header: true });
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "jobs.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  // const handleImport = async (event) => {
  //   const fileInput = document.createElement('input');
  //   fileInput.type = 'file';
  //   fileInput.accept = '.csv';
  //   fileInput.click();

  //   fileInput.addEventListener('change', async (e) => {
  //     const file = e.target.files[0];
  //     if (file) {
  //       try {
  //         const importedJobs = await readCSVFile(file);
  //         const totalJobs = importedJobs.length;
  //         const validJobs = validateJobData(importedJobs);
  //         // Perform the API call to save the data
  //         if (validJobs.length === 0) {
  //           toast.error('No valid data found 0 jobs added.');
  //           return;
  //         }
  //         await importJobsToDatabase(validJobs, totalJobs);
  //         console.log('Data imported successfully.');
  //         console.log(validJobs);
  //       } catch (error) {
  //         console.error('Error reading CSV file:', error);
  //       }
  //     }
  //   });
  // };

  // const importJobsToDatabase = async (jobsData, totalJobs) => {
  //   try {
  //     const addedJobs = jobsData.length;
  //     const res = await dispatch(importJob(jobsData));
  //     toast.success(`Import ${addedJobs} jobs successfully`);
  //     const notImportedJobs = totalJobs - addedJobs;
  //     if (notImportedJobs > 0) {
  //       toast.error(`${notImportedJobs} jobs not imported`);
  //     }
  //   } catch (error) {
  //     console.error('Error saving data to database:', error);
  //     throw error;
  //   }
  // };

  // const downloadCSVTemplate = () => {
  //   const csvContent = jobCSVTamplate();
  //   const blob = new Blob([csvContent], { type: 'text/csv' });
  //   const url = URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = 'job_template.csv';
  //   a.click();
  //   URL.revokeObjectURL(url);
  // };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = jobs.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    let result;
    if (query) {
      result = filter(
        jobs,
        (_inv) => _inv.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    } else {
      result = stabilizedThis.map((el) => el[0]);
    }
    // Always float Priority jobs to the top
    const priority = result.filter((j) => j.status === "priority");
    const rest = result.filter((j) => j.status !== "priority");
    return [...priority, ...rest];
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - jobs.length) : 0;

  const filteredUsers = applySortFilter(
    jobs,
    getComparator(order, orderBy),
    filterName
  );

  const isNotFound = !filteredUsers.length && !!filterName;

  // CR-2026-FE-JOBS-DELETE-CONFIRM 2026-05-05.
  // Dean QA report 2026-05-05 flagged the prior implementation (immediate
  // dispatch on trash-icon click, no confirmation) as a CRITICAL data-loss-
  // risk UX bug. Net root cause: the underlying server is paranoid:true so
  // the row is soft-deleted (recoverable from /var/backups + DB), but a user
  // mis-click looks like permanent loss because the row vanishes from the
  // active list with no recovery affordance in this UI yet.
  // Mitigation here: open a confirmation dialog with a type-DELETE gate +
  // mandatory reason + an explicit "soft delete, recoverable" notice.
  const [deleteJobTarget, setDeleteJobTarget] = useState(null);
  const [deleteJobBusy, setDeleteJobBusy] = useState(false);
  const [deleteJobError, setDeleteJobError] = useState(null);
  const [deleteJobReason, setDeleteJobReason] = useState("");
  const [deleteJobTypeGate, setDeleteJobTypeGate] = useState("");
  const [jobsToast, setJobsToast] = useState(null); // { message, severity }

  const handleDelete = (id) => {
    const target = jobs.find((j) => Number(j.id) === Number(id));
    if (!target) {
      setJobsToast({ message: `Job #${id} not found in current list.`, severity: "warning" });
      return;
    }
    setDeleteJobTarget(target);
    setDeleteJobBusy(false);
    setDeleteJobError(null);
    setDeleteJobReason("");
    setDeleteJobTypeGate("");
  };

  const handleDeleteCancel = () => {
    if (deleteJobBusy) return;
    setDeleteJobTarget(null);
    setDeleteJobError(null);
  };

  const handleDeleteConfirm = async () => {
    if (!deleteJobTarget) return;
    if (deleteJobReason.trim().length < 4) {
      setDeleteJobError("Reason must be at least 4 characters (audit trail).");
      return;
    }
    if (deleteJobTypeGate.trim().toUpperCase() !== "DELETE") {
      setDeleteJobError("Type DELETE to confirm.");
      return;
    }
    setDeleteJobError(null);
    setDeleteJobBusy(true);
    try {
      // Codex F4 fix 2026-05-07: pass the mandatory deletion reason through
      // to the thunk → backend → audit_log. Previously dispatched only the
      // id; the validated reason was discarded and the audit-trail claim
      // in the dialog copy was false. Now V-03 evidence capture is
      // genuine — auditor can SELECT reason FROM audit_log WHERE
      // event_type='JOB-DELETE' and see the operator's stated cause.
      await dispatch(
        deleteJob({ id: deleteJobTarget.id, reason: deleteJobReason })
      ).unwrap?.();
      setJobsToast({
        message: `Deleted "${deleteJobTarget.name || `Job #${deleteJobTarget.id}`}". Soft-delete — server retains the row for audit and recovery (audit_log immutable).`,
        severity: "success",
      });
      setDeleteJobTarget(null);
    } catch (err) {
      // dispatch may not be a thunk that supports .unwrap on this codebase;
      // err may be undefined. Fall back to a generic message + leave dialog open.
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Delete failed. Please retry or check console for details.";
      setDeleteJobError(msg);
    } finally {
      setDeleteJobBusy(false);
    }
  };

  const handleOpenModel = () => {
    setOpenModel(!open);
  };

  const navigate = useNavigate();

  const handleDetail = (id) => {
    // Route merge 2026-05-05: when default base "/jobs", append /detailing
    // to land on the canonical Detailing Workspace. Legacy "/detail-Job" base
    // (used by some callers for back-compat) gets the bare path which then
    // auto-redirects via DetailJobRedirect.
    if (detailBasePath === "/jobs") {
      navigate(`/jobs/${id}/detailing`);
    } else {
      navigate(`${detailBasePath}/${id}`);
    }
  };

  // const handleOpenList = () => {
  //   navigate("/shipping-list");
  // };

  useEffect(() => {
    dispatch(getJobs());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>{moduleTitle} | SFM</title>
      </Helmet>

      {openModel ? (
        <CModel
          isLoading={isJobLoading}
          open={openModel}
          setOpen={setOpenModel}
          filter={"add-job"}
        />
      ) : (
        ""
      )}

      {openUpdateModel ? (
        <CModel
          open={openUpdateModel}
          isLoading={isJobLoading}
          data={selectedRow}
          setOpen={setOpenUpdateModel}
          filter={"edit-job"}
        />
      ) : (
        ""
      )}

      {canViewJobList && (
        <Container>
          <PageHeader
            breadcrumbs={[{ label: moduleTitle }]}
            title={moduleTitle}
            action={<div style={{ display: "flex", gap: "10px" }}>
              {/* <Button
                onClick={handleOpenList}
                variant="contained"
                startIcon={<Iconify icon="eva:plus-fill" />}
              >
                Bill of Lading
              </Button> */}
              {showJobActions && canExportJob && (
                <Button
                  onClick={handleExport}
                  variant="outlined"
                  startIcon={<Iconify icon="ph:download-fill" />}
                >
                  Export Jobs
                </Button>
              )}
              {showJobActions && canAddJob && (
                <Button
                  onClick={handleOpenModel}
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                >
                  New Job
                </Button>
              )}
            </div>}
            guide={{
              why: "Keep every job's drawings, pieces, heats, and shipping in one place — so the whole team works from the same record.",
              who: "Project managers and the QM running each job; the whole team works from it.",
              what: "Your list of fabrication jobs, each a hub for its drawings, piece marks, materials, and progress.",
              how: "Open a job to manage its detailing, pieces, and documents; create a new job to start one.",
              when: "When a contract is awarded and throughout the job, as the work moves from detailing to shipping.",
              standard: "ISO 9001:2015 §8.1",
            }}
          />

          <Card>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <UserListToolbar
                label={"Search jobs..."}
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
              />
              <TablePagination
                rowsPerPageOptions={[10, 25]}
                component="div"
                count={jobs.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <SmartTable tableId="jobs" lockedColumns={["Project Name", "status"]}>
                  <UserListHead
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={jobs.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        const {
                          id,
                          name,
                          status,
                          totalTasks,
                          completedTasks,
                          startDate,
                          endDate,
                        } = row;

                        return (
                          <TableRow
                            hover
                            key={id}
                            tabIndex={-1}
                            onClick={() => handleDetail(id)}
                            sx={{ cursor: "pointer" }}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                            >
                              <Stack direction="row" alignItems="center">
                                <Typography
                                  sx={{ padding: "0px 15px" }}
                                  variant="subtitle2"
                                  noWrap
                                >
                                  {name}
                                </Typography>
                              </Stack>
                            </TableCell>

                            <TableCell align="left">
                              <Label
                                color={
                                  status === "completed"
                                    ? "success"
                                    : status === "in_process"
                                    ? "secondary"
                                    : "error"
                                }
                              >
                                {sentenceCase(status)}
                              </Label>
                            </TableCell>

                            <TableCell align="left">
                              {totalTasks ? totalTasks : 0}
                            </TableCell>
                            <TableCell align="left">
                              {completedTasks ? completedTasks : 0}
                            </TableCell>

                            <TableCell align="left">
                              {startDate ? fDate(startDate) : "_"}
                            </TableCell>

                            <TableCell align="left">
                              {endDate ? fDate(endDate) : "_"}
                            </TableCell>

                            <TableCell
                              align="right"
                              style={{ display: "flex" }}
                            >
                              {showJobActions && canEditJob && (
                                <MenuItem
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedRow(row);
                                    setOpenUpdateModel(!openUpdateModel);
                                  }}
                                >
                                  <Iconify icon={"eva:edit-fill"} />
                                </MenuItem>
                              )}
                              {showJobActions && canDeleteJob && (
                                <MenuItem
                                  sx={{ color: "error.main" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete(id);
                                  }}
                                >
                                  <Iconify icon={"eva:trash-2-outline"} />
                                </MenuItem>
                              )}
                              {canDeatilJobList && (
                                <MenuItem
                                  sx={{ color: "error.main" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDetail(id);
                                  }}
                                >
                                  <Iconify icon={"eva:info-outline"} />
                                </MenuItem>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete
                              words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </SmartTable>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 25]}
              component="div"
              count={filteredUsers.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      )}

      {/* CR-2026-FE-JOBS-DELETE-CONFIRM 2026-05-05 — confirmation dialog
          for the trash-icon click. Closes Dean QA report 2026-05-05 #1
          (CRITICAL: no confirmation, immediate delete). The server is
          paranoid:true so the row is recoverable even after this action,
          but the UX now respects the user's intent. */}
      <Dialog
        open={!!deleteJobTarget}
        onClose={handleDeleteCancel}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, color: "error.main" }}>
          <WarningAmberRounded />
          Delete job?
        </DialogTitle>
        <DialogContent>
          <Alert severity="warning" sx={{ mb: 2 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Soft delete — recoverable
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              The job row is marked deleted on the server but kept in the database
              for recovery. The audit_log entry persists indefinitely.
              Approved drawings and signed records associated with this job
              remain intact (records preservation per AISC 303 §4 / ISO 9001 §7.5.3).
            </Typography>
          </Alert>

          <Box sx={{ p: 2, mb: 2, border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {deleteJobTarget?.name || `Job #${deleteJobTarget?.id ?? ""}`}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Status: {deleteJobTarget?.status || "—"} · ID #{deleteJobTarget?.id ?? "—"}
            </Typography>
          </Box>

          <TextField
            fullWidth
            required
            multiline
            rows={2}
            label="Reason for deletion (required, min 4 chars)"
            placeholder="e.g., Created in error; consolidated into another job; QA test artefact"
            value={deleteJobReason}
            onChange={(e) => setDeleteJobReason(e.target.value)}
            error={deleteJobReason.length > 0 && deleteJobReason.trim().length < 4}
            helperText={`${deleteJobReason.trim().length} / min 4`}
            sx={{ mb: 2 }}
            autoFocus
            disabled={deleteJobBusy}
          />

          <TextField
            fullWidth
            required
            label="Type DELETE to confirm"
            value={deleteJobTypeGate}
            onChange={(e) => setDeleteJobTypeGate(e.target.value)}
            error={
              deleteJobTypeGate.length > 0 &&
              deleteJobTypeGate.trim().toUpperCase() !== "DELETE"
            }
            helperText={
              deleteJobTypeGate.trim().toUpperCase() === "DELETE"
                ? "Confirmed."
                : "Exact match required (case-insensitive)."
            }
            disabled={deleteJobBusy}
          />

          {deleteJobError && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {deleteJobError}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} disabled={deleteJobBusy}>
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            disabled={
              deleteJobBusy ||
              deleteJobReason.trim().length < 4 ||
              deleteJobTypeGate.trim().toUpperCase() !== "DELETE"
            }
            color="error"
            variant="contained"
            startIcon={<Inventory2Outlined />}
          >
            {deleteJobBusy ? "Deleting…" : "Delete job"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!jobsToast}
        autoHideDuration={6000}
        onClose={() => setJobsToast(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        {jobsToast ? (
          <Alert
            onClose={() => setJobsToast(null)}
            severity={jobsToast.severity}
            sx={{ width: "100%" }}
          >
            {jobsToast.message}
          </Alert>
        ) : null}
      </Snackbar>
    </>
  );
}
